import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedFileDownload } from '@eggplant/data-request'
import type { EnvironmentsSecretRequestShape } from '@eggplant/types'

interface Props {
  name: string
  params?: EnvironmentsSecretRequestShape
  onSuccess: () => void
}

const DownloadAiEnvironmentSecretsRequest = ({
  name,
  params,
  onSuccess
}: Props) => {
  const url = `${AI_API_SERVICE}/agents/generate_secrets`

  return (
    <AuthenticatedFileDownload
      fileType='text/ini'
      filename={`${name}.ini`}
      method='post'
      onSuccess={onSuccess}
      params={params}
      url={url}
    />
  )
}

export default DownloadAiEnvironmentSecretsRequest
